'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPersonOutline = function MdPersonOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 21.6c4.5 0 13.4 2.3 13.4 6.8v5h-26.8v-5c0-4.5 8.9-6.8 13.4-6.8z m0-15c3.7 0 6.6 3.1 6.6 6.8s-2.9 6.6-6.6 6.6-6.6-3-6.6-6.6 2.9-6.8 6.6-6.8z m0 18.2c-4.9 0-10.2 2.5-10.2 3.6v1.8h20.4v-1.8c0-1.1-5.3-3.6-10.2-3.6z m0-15c-2 0-3.5 1.6-3.5 3.6s1.6 3.4 3.5 3.4 3.5-1.5 3.5-3.4-1.6-3.6-3.5-3.6z' })
        )
    );
};

exports.default = MdPersonOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/person-outline.js
// module id = 3631
// module chunks = 168707334958949